import AsyncStorage from '@react-native-async-storage/async-storage';

const FAVORITE_TOKEN_SYMBOLS_KEY = '@oneapp:favorite-token-symbols:v1';

export const normalizeFavoriteSymbols = (symbols: unknown): string[] => {
  if (!Array.isArray(symbols)) { return []; }
  return Array.from(new Set(
    symbols
      .filter((value): value is string => typeof value === 'string')
      .map(value => value.trim().toUpperCase())
      .filter(Boolean),
  )).sort();
};

export const getFavoriteTokenSymbols = async (): Promise<string[]> => {
  try {
    const raw = await AsyncStorage.getItem(FAVORITE_TOKEN_SYMBOLS_KEY);
    return raw ? normalizeFavoriteSymbols(JSON.parse(raw)) : [];
  } catch {
    return [];
  }
};

export const setFavoriteTokenSymbols = async (symbols: string[]): Promise<string[]> => {
  const normalized = normalizeFavoriteSymbols(symbols);
  await AsyncStorage.setItem(FAVORITE_TOKEN_SYMBOLS_KEY, JSON.stringify(normalized));
  return normalized;
};

export const toggleFavoriteTokenSymbol = async (
  current: string[],
  symbol: string,
): Promise<string[]> => {
  const normalizedSymbol = symbol.trim().toUpperCase();
  const existing = new Set(normalizeFavoriteSymbols(current));
  if (existing.has(normalizedSymbol)) {
    existing.delete(normalizedSymbol);
  } else if (normalizedSymbol) {
    existing.add(normalizedSymbol);
  }
  return setFavoriteTokenSymbols(Array.from(existing));
};
